import _styled, { default as _styled2, default as _styled3 } from "styled-components";
/* eslint-disable jsx-a11y/label-has-associated-control */
var _templateObject, _templateObject2;
var _excluded = ["$completed", "className", "description", "disabled", "error", "feedback", "id", "label", "labelHidden", "prefixSymbol", "required", "type", "value"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef, useState } from 'react';
import { IconVisibilityOff } from "../../foundations/Iconography/IconVisibilityOff";
import { IconVisibilityOn } from "../../foundations/Iconography/IconVisibilityOn";
import { FieldWrapper } from "../FieldWrapper/FieldWrapper";
import * as styles from "./InputField.styles";
import { getAriaDescribedByForInputField } from "../../../utils/getAriaDescribedByForInputField";
export var INPUT_FIELD_CLASSNAME = 'input-field__input';
var VisibilityButton = function VisibilityButton(_ref) {
  var isVisible = _ref.isVisible,
    onClick = _ref.onClick,
    size = _ref.size;
  var Icon = isVisible ? IconVisibilityOn : IconVisibilityOff;
  return /*#__PURE__*/React.createElement(_StyledButton, {
    "aria-checked": isVisible,
    "aria-label": isVisible ? 'Hide password' : 'Show password',
    onClick: onClick,
    role: "switch",
    type: "button",
    $_css: styles.visibilityButton
  }, /*#__PURE__*/React.createElement(Icon, {
    color: "var(--neutral-black-base)",
    height: size,
    width: size
  }));
};
export var InputField = /*#__PURE__*/forwardRef(function (_ref2, forwardedRef) {
  var _ref2$$completed = _ref2.$completed,
    $completed = _ref2$$completed === void 0 ? false : _ref2$$completed,
    className = _ref2.className,
    description = _ref2.description,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    error = _ref2.error,
    feedback = _ref2.feedback,
    id = _ref2.id,
    label = _ref2.label,
    _ref2$labelHidden = _ref2.labelHidden,
    labelHidden = _ref2$labelHidden === void 0 ? false : _ref2$labelHidden,
    _ref2$prefixSymbol = _ref2.prefixSymbol,
    prefixSymbol = _ref2$prefixSymbol === void 0 ? undefined : _ref2$prefixSymbol,
    _ref2$required = _ref2.required,
    required = _ref2$required === void 0 ? false : _ref2$required,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? 'text' : _ref2$type,
    _ref2$value = _ref2.value,
    value = _ref2$value === void 0 ? '' : _ref2$value,
    inputProps = _objectWithoutProperties(_ref2, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setVisible = _useState2[1];
  var isPasswordInput = type === 'password';
  var fieldId = "".concat(id, "-input");
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(FieldWrapper, {
    $completed: $completed,
    description: description,
    error: error,
    feedback: feedback,
    fieldId: fieldId,
    label: label,
    labelHidden: labelHidden
  }, prefixSymbol && /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css2: styles.prefixSymbol
  }, prefixSymbol), /*#__PURE__*/React.createElement(_StyledInput, _extends({
    "aria-describedby": getAriaDescribedByForInputField({
      fieldId,
      description,
      error
    }),
    "aria-invalid": !!error,
    "aria-required": required,
    className: INPUT_FIELD_CLASSNAME,
    disabled: disabled,
    type: isPasswordInput && isVisible ? 'text' : type,
    value: value
  }, inputProps, {
    id: fieldId,
    ref: forwardedRef,
    $_css3: prefixSymbol ? styles.inputWithPrefixSymbol : styles.input
  })), isPasswordInput && !disabled && /*#__PURE__*/React.createElement(VisibilityButton, {
    isVisible: isVisible,
    onClick: function onClick() {
      return setVisible(function (prev) {
        return !prev;
      });
    },
    size: 16
  })));
});
var _StyledButton = _styled("button")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledInput = /*#__PURE__*/_styled3("input").withConfig({
  displayName: "InputField___StyledInput",
  componentId: "sc-1fbpgce-0"
})(["", ""], function (p) {
  return p.$_css3;
});